/* ─────────────────────────────────────────────────────────────
   Shared static data for built-in select renderers.
   ───────────────────────────────────────────────────────────── */

/** ISO-2 country code → ISO-4217 currency code. Exported so renderers and pages can share it. */
export const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  GB: 'GBP', US: 'USD', EU: 'EUR', DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR',
  NL: 'EUR', BE: 'EUR', AT: 'EUR', PT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR',
  LU: 'EUR', MT: 'EUR', CY: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR',
  LT: 'EUR', AU: 'AUD', CA: 'CAD', JP: 'JPY', CN: 'CNY', HK: 'HKD',
  SG: 'SGD', IN: 'INR', AE: 'AED', SA: 'SAR', CH: 'CHF', SE: 'SEK',
  NO: 'NOK', DK: 'DKK', NZ: 'NZD', ZA: 'ZAR', BR: 'BRL', MX: 'MXN',
  KR: 'KRW', TW: 'TWD', MY: 'MYR', TH: 'THB', ID: 'IDR', PH: 'PHP',
  PK: 'PKR', BD: 'BDT', LK: 'LKR', NG: 'NGN', KE: 'KES', GH: 'GHS',
  EG: 'EGP', TZ: 'TZS', UG: 'UGX', ZM: 'ZMW', RW: 'RWF',
  IL: 'ILS', TR: 'TRY', RU: 'RUB', PL: 'PLN', CZ: 'CZK', HU: 'HUF',
  RO: 'RON', BG: 'BGN', HR: 'HRK', RS: 'RSD', UA: 'UAH',
  AR: 'ARS', CL: 'CLP', CO: 'COP', PE: 'PEN', VE: 'VES',
};

/** Standard financial year-end dates (last day of each month). Stored as "DD Month" text matching BE format. */
export const FYE_OPTIONS = [
  { value: '31 January',  label: '31 January'  },
  { value: '28 February', label: '28 February' },
  { value: '31 March',    label: '31 March'    },
  { value: '30 April',    label: '30 April'    },
  { value: '31 May',      label: '31 May'      },
  { value: '30 June',     label: '30 June'     },
  { value: '31 July',     label: '31 July'     },
  { value: '31 August',   label: '31 August'   },
  { value: '30 September',label: '30 September'},
  { value: '31 October',  label: '31 October'  },
  { value: '30 November', label: '30 November' },
  { value: '31 December', label: '31 December' },
];

export const CURRENCIES = [
  { value: "SGD", label: "SGD — Singapore Dollar" },
  { value: "USD", label: "USD — US Dollar" },
  { value: "EUR", label: "EUR — Euro" },
  { value: "GBP", label: "GBP — British Pound" },
  { value: "JPY", label: "JPY — Japanese Yen" },
  { value: "AUD", label: "AUD — Australian Dollar" },
  { value: "CAD", label: "CAD — Canadian Dollar" },
  { value: "CHF", label: "CHF — Swiss Franc" },
  { value: "HKD", label: "HKD — Hong Kong Dollar" },
  { value: "INR", label: "INR — Indian Rupee" },
  { value: "BRL", label: "BRL — Brazilian Real" },
  { value: "AED", label: "AED — UAE Dirham" },
  { value: "CNY", label: "CNY — Chinese Yuan" },
  { value: "KRW", label: "KRW — South Korean Won" },
  { value: "MYR", label: "MYR — Malaysian Ringgit" },
  { value: "NZD", label: "NZD — New Zealand Dollar" },
  { value: "THB", label: "THB — Thai Baht" },
  { value: "IDR", label: "IDR — Indonesian Rupiah" },
  { value: "PHP", label: "PHP — Philippine Peso" },
  { value: "SEK", label: "SEK — Swedish Krona" },
  { value: "NOK", label: "NOK — Norwegian Krone" },
  { value: "DKK", label: "DKK — Danish Krone" },
  { value: "ZAR", label: "ZAR — South African Rand" },
  { value: "MXN", label: "MXN — Mexican Peso" },
];
